import { render } from "./CloseModalEditorCmp.vue?vue&type=template&id=aac80056"
import script from "./CloseModalEditorCmp.vue?vue&type=script&lang=js"
export * from "./CloseModalEditorCmp.vue?vue&type=script&lang=js"

import "./CloseModalEditorCmp.vue?vue&type=style&index=0&id=aac80056&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__